<app-section #parentSection
             class="offer-modifications offer-modifications--ac-variants"
             *ngIf="sectionVisible"
             [title]="title"
             [key]="key"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [formConfig]="formConfig">

  <ng-template #section>

  <div *ngIf="contentVisible">

      <a *ngIf="compareCoveragesAllowed" class="offer-modifications__link-btn" (click)="compareCoverages()">
          {{ 'OFFER_MODIFICATIONS.compareCoverages' | translate }}
      </a>

    <div class="offer-modifications__content">
        <ng-container *ngFor="let mod of visibleModifications">
            <app-radio-tile *ngIf="shouldDisplayModification(mod.code)"
                            [bean]="bean"
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[mod.code]"
                            [fieldConfig]="formFactoryService.fieldConfig(mod.code, formConfig)"
                            (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)">
            </app-radio-tile>
        </ng-container>

        <app-number-step-input *ngIf="offerModificationsService.vehicleValueModificationEnabled"
                               class="offer-modifications__vehicle-value"
                               [bean]="bean"
                               [errorsMap]="formFactoryService.errorsMap"
                               [control]="formGroup.controls['vehicleValue']"
                               [fieldConfig]="formFactoryService.fieldConfig('vehicleValue', formConfig)"
                               (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)">
        </app-number-step-input>

        <ng-container *ngIf="callCenterSectionVisible">
            <hr>

            <ng-container *ngFor="let mod of invisibleModifications">
                <app-radio-tile *ngIf="shouldDisplayModification(mod.code)"
                                [bean]="bean"
                                [errorsMap]="formFactoryService.errorsMap"
                                [control]="formGroup.controls[mod.code]"
                                [fieldConfig]="formFactoryService.fieldConfig(mod.code, formConfig)"
                                (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)">
                </app-radio-tile>
            </ng-container>
        </ng-container>

        <div class="offer-modifications__recalculate-btn-wrapper"
             *ngIf="buttonVisible">
            <button class="btn btn--primary-inverted btn--big offer-modifications__recalculate-btn"
                    (click)="recalculatePremium()">
                {{ 'OFFER_MODIFICATIONS.recalculate' | translate }}
            </button>
        </div>
    </div>
  </div>

  <div *ngIf="!contentVisible"
       class="offer-modifications__content-placeholder">
      <app-loading-content-placeholder [config]="loadingContentPlaceholderConfig"
      ></app-loading-content-placeholder>
  </div>

  </ng-template>

</app-section>
